import axios from 'axios';
import { api, headers } from '../../app/conf';

export const getTicketsTypesService = (token) =>
    axios({
        method: 'get',
        url: `${api}/v1/tasksCasesTypes`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    })